import { Modal } from 'react-bootstrap';
import { useAppContext } from '../Contexts/AppContext';
import SignIn from '../Pages/Login';

const LoginModal = () => {
    const { showLoginModal, setShowLoginModal } = useAppContext();

    return (
        <Modal show={showLoginModal} onHide={() => setShowLoginModal(false)} centered>
            <Modal.Header closeButton className='bg-secondary-subtle'>
                <Modal.Title>כניסה לחשבון</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SignIn onSuccess={() => setShowLoginModal(false)} />
            </Modal.Body>
        </Modal>
    );
};

export default LoginModal;
